import React from 'react';
import { moments, momentsTitle, needs } from '../data/content';
const needColor = (label: string) => needs.find(need => need.label === label)?.color ?? '#d8b35a';
export function UseMoments() {
  return <section className="bg-night-panel" data-id="element-205" data-mp="2tpvr1rgona3">
      <div className="mx-auto max-w-content px-5 py-14 sm:px-6 lg:py-24" data-id="element-206" data-mp="2wkdglj3btzt">
        <div className="mx-auto max-w-2xl text-center" data-id="element-207" data-mp="3uzli3pwd9p85">
          <h2 className="font-display text-[1.875rem] font-semibold leading-tight tracking-tight text-parchment sm:text-4xl" data-id="element-208" data-mp="vivnemsl779a">
            {momentsTitle}
          </h2>
          <p className="mt-4 font-sans text-base leading-relaxed text-parchment/70" data-id="element-209" data-mp="qm5841olwfox">
            Situaciones de todos los días en las que una Palabra de Dios hace la diferencia.
          </p>
        </div>

        <ul className="mx-auto mt-10 grid max-w-5xl gap-x-10 border-t border-night-line md:grid-cols-2" data-id="element-210" data-mp="hpxmym1aeoyv">
          {moments.map(moment => <li key={moment.title} className="border-b border-night-line py-6" data-id="element-211" data-mp="19ioe4i445nh9">
              <span className="inline-flex items-center gap-2 font-sans text-xs font-semibold text-parchment/60" data-id="element-212" data-mp="1pul2dn1vtvnk">
                <span aria-hidden="true" className="h-2 w-2 rounded-full" style={{
              backgroundColor: needColor(moment.need)
            }} data-id="element-213" data-mp="1uuh7xqq89v58" />
                {moment.need}
              </span>
              <h3 className="mt-2 font-display text-xl font-semibold leading-snug text-parchment" data-id="element-214" data-mp="1l2besdo8p7og">
                {moment.title}
              </h3>
              <p className="mt-1.5 font-sans text-[0.95rem] leading-relaxed text-parchment/70" data-id="element-215" data-mp="1c3zsgnueow1t">
                {moment.description}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}